<template>
  <div>
    <b-row>
      <b-table
        ref="selectableTable"
        id="table-tabela-proceda"
        hover
        :items="data"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
      ></b-table>
    </b-row>
    <b-row>
      <b-col sm="4" md="4" lg="4">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        ></b-pagination>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <label
          for="perPageSelect"
        >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{rows}}</label>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <b-row>
          <b-col sm="3" md="3" lg="3">
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col style="padding-left: 0px;">
            <label for="perPageSelect">registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>


<script>
export default {
  name: "CargoImportDefails",
  props: {
    id: Number,
    lastRefresh: Date,
  },
  created: function () {
    this.loadData();
  },
  data: function () {
    return {
      data: null,
      fields: [
        {
          label: "Nome do arquivo",
          key: "nomeArquivo",
          sortable: true,
        },
        {
          label: "Descrição da ocorrência",
          key: "descricao",
          sortable: true,
        },
      ],
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100, 150],
      currentPage: 1,
      selectModeTabelaProceda: "single",
      selectedTabelaProceda: [],
    };
  },
  computed: {
    rows() {
      if (this.data) {
        return this.data.length;
      }
      return 0;
    },
    paginationFrom() {
      return this.perPage * (this.currentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.perPage;
      if (to > this.rows) return this.rows;
      return to;
    },
  },
  watch: {
    id() {
      this.loadData();
    },
    lastRefresh() {
      this.loadData();
    },
  },
  methods: {
    async loadData() {
      this.$api
        .get("/cargo/storyDetails/" + this.id.toString())
        .then((response) => {
          this.data = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>